import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.modal = new window.bootstrap.Modal(this.element)
    this.modal.show()
    this.element.addEventListener('hidden.bs.modal', () => {
      this.element.closest('turbo-frame').innerHTML = ''
    })
  }

  disconnect() {
    // When the frame content is cleared by a turbo stream (e.g. after successful
    // save), the modal element is removed from the DOM before Bootstrap can clean
    // up its own backdrop. Do it manually here.
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
    document.body.classList.remove('modal-open')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
    this.modal?.dispose()
  }
}
